module.exports = __webpack_public_path__ + "img/06.428423fd.png";